import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import TermsModal from "../../components/TermsModal";
import { getTerms, getPublicTerms, cleanTerms } from "../../actions/terms";
import { TermsContainerProps } from "../../interfaces/containers";

function mapStateToProps(state: TermsContainerProps) {
    return {
        user: state.auth.user,
        terms: state.terms
    };
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getTerms,
        getPublicTerms,
        cleanTerms
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsModal);
